// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// analysis statuses will initially be sorted by:
// submit date descending
// band ascending
// analysis type (env, intra, es)

const initialAnalysisSort = data => (
  data.sort((a, b) => {
    // submit date descending
    if (a.submitTime > b.submitTime) {
      return -1
    } else if (a.submitTime < b.submitTime) {
      return 1
    }

    // band (the actual GHz value) ascending
    if (a.band < b.band) {
      return -1
    } else if (a.band > b.band) {
      return 1
    }

    return (
      a.analysisTypeId < b.analysisTypeId
        ? -1
        : 1
    )
  })
)

export default initialAnalysisSort
